"use client";

import { FC } from "react";
import UpdateAddtionalEntryDetails from "../update-additional-entry-details/update-additional-entry-details";
import { TaxIncentiveStatuses } from "@/prisma-package/src";
import StatusSelect from "../status-select/status-select";
import QualificationExplainer from "./qualification-explainer";
import { useAtomValue } from "jotai";
import {
  EntryDetailsDrawerData,
  drawerAtom,
} from "@/app/_lib/atoms/drawer.atom";
import { formatMoney } from "@/app/_lib/utils/format-money.utils";

const DetailsDrawer: FC = () => {
  const drawer = useAtomValue(drawerAtom);

  if (!drawer.data) return null;

  const { fullEntryData, projectId } = drawer.data as EntryDetailsDrawerData;

  return (
    <div>
      <h2 className="text-2xl pb-4 border-b border-gray-200">
        Additional Details for Transaction {fullEntryData.transactionNumber}
      </h2>
      <div className="flex flex-col gap-14 py-6">
        <div>
          <h3 className="text-xl mb-4">Tax Incentive Status:</h3>
          <StatusSelect
            entryId={fullEntryData.id}
            status={
              fullEntryData.taxIncentiveStatus ||
              TaxIncentiveStatuses.PENDING_REVIEW
            }
            amount={fullEntryData.amount}
            taxIncentiveAmount={fullEntryData.taxIncentiveAmount}
          />
        </div>
        <QualificationExplainer projectId={projectId} entry={fullEntryData} />
        <div>
          <h3 className="text-xl mb-4">Vendor Details:</h3>
          <div>
            <p>
              <strong>Name:</strong>
              <span className="pl-2">{fullEntryData.vendorName ?? "None"}</span>
            </p>
          </div>
        </div>
        <div>
          <h3 className="text-xl mb-4">Amount:</h3>
          <div>
            <strong className="text-lg">
              {formatMoney(fullEntryData.amount)}
            </strong>
          </div>
        </div>
        <div>
          <h3 className="text-xl mb-4">Tax Incentive Amount:</h3>
          <div>
            <strong className="text-lg">
              {formatMoney(fullEntryData.taxIncentiveAmount ?? 0, {
                inputFormat: "cents",
              })}
            </strong>
          </div>
        </div>
        <div>
          <h3 className="text-xl mb-4">Location:</h3>
          <div>
            <strong className="text-lg">
              {fullEntryData.location ?? "None"}
            </strong>
          </div>
        </div>
        <div>
          <h3 className="text-xl mb-2">Additional Data:</h3>
          <p className="max-w-lg text-gray-400 mb-4">
            Adding the following additional data can allow Conduiit to add more
            specificity to this entry where applicable.
          </p>
          <UpdateAddtionalEntryDetails />
        </div>
      </div>
    </div>
  );
};

export default DetailsDrawer;
